import { createContext, useContext, useEffect, useReducer, useState } from 'react';
import ajaxVoucher from '../util/remote/ajaxVoucher';

const initialState = { 
  voucherStats: {
      active: 0,
      redeemedToday: 0,
      revenueToday: 0,
      expiringSoon: 0,
      walletConnected: false,
    },
    statsLoaded: false,
    transactions: null,
    metaData: null,
    currentPage: 1,
    mounted: false,
    recentVoucherActivity: null,
    trafficUsage: null
};

const reducer = (state, action) => {
    switch (action.type) {
      case 'CLEAR':
        return { initialState};  // Reset state completely
      default:
        return {...state, [action.type]: action.payload};
    }
  };


const VoucherContext = createContext();

export const VoucherProvider = ({children}) =>{
  const [state, dispatch] = useReducer(reducer, initialState);
  const [filters, setFilters] = useState({ q: '', plan_id: '', status: '', source: '', from: '', to: '' });

  useEffect(()=>{
      if(state.mounted){
        getVoucherTransactions(false, true);
      }
    }, [state.currentPage, state.mounted])

  const getVoucherStats = async (refresh = false) => {
    if(!refresh && state.statsLoaded) return;
    if(refresh){
        dispatch({ type: 'voucherStats', payload: initialState.voucherStats });
        dispatch({ type: 'statsLoaded', payload: false });
    }
    const server_response  = await ajaxVoucher.fetchStats();
    if(server_response.status === "OK"){
        dispatch({ type: 'voucherStats', payload: server_response.details });
        dispatch({ type: 'statsLoaded', payload: true });
    }
  };

  const getVoucherTransactions = async (refresh = false, nextPage = false) => {
    if(!refresh && Array.isArray(state.transactions) && !nextPage) return;
    if(refresh){
        setCurrentPage(1);
        dispatch({ type: 'transactions', payload: null });
        dispatch({ type: 'metaData', payload: null });
    }
    const server_response  = await ajaxVoucher.fetchTransactions({ page: refresh ? 1 : state.currentPage, filters });
    if(server_response.status === "OK"){
        dispatch({ type: 'transactions', payload: server_response.details.data });
        dispatch({ type: 'metaData', payload: server_response.details.meta });
    }else{
        dispatch({ type: 'transactions', payload: '404' });
        dispatch({ type: 'metaData', payload: null });
    }
  };

  const setCurrentPage = (page)=>{
    dispatch({ type: 'currentPage', payload: page });
  }

  const setMounted = (value) => {
    dispatch({ type: 'mounted', payload: value });
  };

  const getRecentVoucherActivity = async (refresh = false) => {
    if (!refresh && Array.isArray(state.recentVoucherActivity)) return;
    const server_response = await ajaxVoucher.fetchRecentDeviceActivity();
    if (server_response.status === "OK") {
      dispatch({ type: 'recentVoucherActivity', payload: server_response.details });
    }else{
      dispatch({ type: 'recentVoucherActivity', payload: '404' });
    }
  };

  const getTrafficUsage = async (refresh = false) => {
    if (!refresh && state.trafficUsage) return;
    const server_response = await ajaxVoucher.fetchTrafficUsage();
    if (server_response.status === "OK") {
      dispatch({ type: 'trafficUsage', payload: server_response.details });
    }
  };

  return(
    <VoucherContext.Provider value={{
      ...state,
      filters,
      setFilters,
      dispatch,
      getVoucherStats,
      getVoucherTransactions,
      setCurrentPage ,
      setMounted,
      getRecentVoucherActivity,
      getTrafficUsage
      }}>
      {children}
    </VoucherContext.Provider>
  )

}

export const useVoucher = ()=>useContext(VoucherContext);

